import React from 'react'

import useStyles from './styles'
import OverflowText from '@SonarCX/components/atoms/OverflowText'

type ClickableAltProps = {
  onClick: () => void
  children: React.ReactNode
}

const ClickableAlt: React.FC<ClickableAltProps> = props => {
  const classes = useStyles()

  return (
    <OverflowText className={classes.root}>
      {props.children}
    </OverflowText>
  )
}

export default ClickableAlt
